enum FileType {
  image,
  file,
  canvas,
  base64url,
  url,
  base64string,
  imageData
}

// case FileType.image:
// case FileType.file:
// case FileType.canvas:
// case FileType.base64url:
// case FileType.url:
// case FileType.base64string:

export default class ImagePhaseShifter {
  // convert to base64 url
  public static async toBase64url(
    src: HTMLImageElement | File | HTMLCanvasElement | string | ImageData,
    ext?: string
  ): Promise<string> {
    switch (this.getType(src)) {
      case FileType.image:
      case FileType.imageData:
      case FileType.url: {
        const canvas = await this.toCanvas(src)
        return this.toBase64url(canvas)
      }
      case FileType.file: {
        const fr = new FileReader()
        const promise = new Promise<string>((resolve) => {
          fr.onload = (evt: any) => {
            const base64url = evt.target.result
            resolve(base64url)
          }
        })
        fr.readAsDataURL(src as File)
        return promise
      }
      case FileType.canvas:
        return (src as HTMLCanvasElement).toDataURL(
          ext ? `images/${ext}` : 'image/jpeg'
        )
      case FileType.base64url:
        return src as string
      case FileType.base64string:
        return `data:image/jpeg;base64,${src}`
    }
  }
  //   public static async toBase64string(src: HTMLImageElement | File | HTMLCanvasElement | string): Promise<string> {
  //     const url = this.toBase64url(src);
  //   }
  // Canvasへ変換する
  public static async toCanvas(
    src: HTMLImageElement | File | HTMLCanvasElement | string | ImageData
  ): Promise<HTMLCanvasElement> {
    switch (this.getType(src)) {
      case FileType.image:
        return this.img2canvas(src as HTMLImageElement)
      case FileType.imageData:
        return this.imgData2canvas(src as ImageData)
      case FileType.file:
        return this.toCanvas(await this.toBase64url(src))
      case FileType.canvas:
        return src as HTMLCanvasElement
      case FileType.base64url:
      case FileType.url: {
        const url_img = new Image()
        const promise = new Promise<HTMLImageElement>((resolve) => {
          url_img.onload = () => resolve(url_img)
        })
        url_img.src = src as string
        return this.toCanvas(await promise)
      }
      case FileType.base64string:
        return this.toCanvas(await this.toBase64url(src))
    }
  }

  public static async toImage(
    src: HTMLImageElement | File | HTMLCanvasElement | string | ImageData
  ): Promise<HTMLImageElement> {
    switch (this.getType(src)) {
      case FileType.image:
        return src as HTMLImageElement
      case FileType.imageData:
        return this.toImage(this.imgData2canvas(src as ImageData))
      case FileType.file:
      case FileType.canvas:
      case FileType.base64string:
        return this.toImage(await this.toBase64url(src))
      case FileType.base64url:
      case FileType.url: {
        const url_img = new Image()
        const promise = new Promise<HTMLImageElement>((resolve) => {
          url_img.onload = () => resolve(url_img)
        })
        url_img.src = src as string
        return this.toImage(await promise)
      }
    }
  }

  public static async toImageData(
    src: HTMLImageElement | File | HTMLCanvasElement | string | ImageData
  ): Promise<ImageData> {
    switch (this.getType(src)) {
      case FileType.canvas: {
        const canvas = src as HTMLCanvasElement
        const ctx = canvas.getContext('2d')!
        const inImageData = ctx.getImageData(0, 0, canvas.width, canvas.height)
        return inImageData
      }
      default:
        return this.toImageData(await this.toCanvas(src))
    }
  }

  static getType(
    src: HTMLImageElement | File | HTMLCanvasElement | string | ImageData
  ): FileType {
    if (src instanceof HTMLImageElement) {
      return FileType.image
    } else if (src instanceof HTMLCanvasElement) {
      return FileType.canvas
    } else if (src instanceof File) {
      return FileType.file
    } else if (src instanceof ImageData) {
      return FileType.imageData
    } else if (
      src.match(/^http:/) ||
      src.match(/^https:/) ||
      src.match(/^file:/)
    ) {
      return FileType.url
    } else if (src.match(/^data:/)) {
      return FileType.base64url
    } else {
      return FileType.base64string
    }
  }

  private static img2canvas(img: HTMLImageElement) {
    const canvas = document.createElement('canvas')
    canvas.width = img.width
    canvas.height = img.height
    const ctx = canvas.getContext('2d')!
    ctx.drawImage(img, 0, 0)
    return canvas
  }

  private static imgData2canvas(img: ImageData) {
    const canvas = document.createElement('canvas')
    canvas.width = img.width
    canvas.height = img.height
    const ctx = canvas.getContext('2d')!
    ctx.putImageData(img, 0, 0)
    return canvas
  }
}
